export const IS_LOCAL = process.env.REACT_APP_ENVIRONMENT === "development";
export const IS_UAT = process.env.REACT_APP_ENVIRONMENT === "uat";
export const IS_PROD = process.env.REACT_APP_ENVIRONMENT === "production";
export const FULLSTORY_ENABLED = !!process.env.REACT_APP_FULLSTORY_ORG_ID;
export const PWB_EVENTS = "pwb_events";
